"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackBenefitDialogController = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../../components");
var _constants = require("../../constants");
var _constantsGenerated = require("../../constants-generated");
var _contexts = require("../../contexts");
var _logger2 = require("../../logger");
var _ApiProvider = require("../ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file @preserve -- Controller

const localLogger = _logger2.mainLogger.createChild('FeedbackBenefitDialogController');
// istanbul ignore next @preserve -- No need to test logging.
const onError = error => localLogger.error(new Error('TranslationsProvider fetching failed', {
  cause: error
}));

/**
 * Accepts config data, fetches data for FeedbackBenefitDialog and renders it if
 * OpenFeedbackBenefitDialog event is dispatched
 */
const FeedbackBenefitDialogController = ({
  translations
}) => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    customerId,
    token
  } = (0, _auth.useToken)();
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
          areaName: "FeedbackBenefitDialogController",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
            clientFetchConfiguration: initialOpenDone ? {
              baseUrl: staticApiUrl,
              onError,
              tenant
            } : undefined,
            defaultTranslationsWithNamespaces: {
              [_constants.translationsNamespace]: _constants.defaultTranslations
            },
            language: language,
            translationsWithNamespaces: translations ? {
              [_constants.translationsNamespace]: translations
            } : undefined,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _constants.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.FeedbackBenefitDialogProvider, {
                open: open,
                onClose: onClose,
                onOpen: onOpen,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
                    disableFetching: !initialOpenDone,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
                      customerId: customerId,
                      language: language,
                      sourceAppName: _constantsGenerated.PACKAGE_NAME,
                      tenant: tenant,
                      token: token,
                      children: initialOpenDone ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackBenefitDialog, {}) : null
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.FeedbackBenefitDialogController = FeedbackBenefitDialogController;
